import React from 'react';
// import Flickity from 'react-flickity-component';
// import prev from '../../assets/icon-prev@2x.png';



class Picture extends React.Component {
  // constructor(props) {
  //   super(props);
  // }

  // componentDidMount = () => {
  //
  // }

  render() {
      // console.log(this.props);
      const data = this.props.data;

      return (
          <picture className={this.props.width === 'Side-by-Side' ? this.props.width.toLowerCase(): ''}>
          { data !== undefined ?
            <img src={data.url} alt={data.description} className={`project-image ${this.props.width ? this.props.width.toLowerCase() : ''}`} />:null

          }
          </picture>
      );
  }
}

export default Picture;



// WEBPACK FOOTER //
// ./src/scripts/components/picture.js